module.exports = __webpack_public_path__ + "img/404.ca31b553.png";